export const WELCOME_PAGE_PATH = 'welcome'

export const STATIC_APP_PATHS = {
    orderListPage: '/orders/overview',
    taskOverviewPage: '/tasks',
    assetListPage: '/assets',
    userDetailsPage: '/settings/profile',
    notificationSettingsPage: '/settings/notifications',
    createOrderPage: '/orders/new',
    analysisPage: '/analysis',
    threadOverviewPage: '/threads',
    dashboard: '/dashboard',
    playground: '/playground',
    playgroundValXmlExtractor: '/playground/val-xml-extractor',
    playgroundTenantListImport: '/playground/tenant-list-import',
    playgroundPdfValidator: '/playground/pdf-validator',
}

export const DYNAMIC_APP_PATHS = {
    orderDetailsPage: 'orders/:orderId/overview',
    orderThreadListPage: 'orders/:orderId/threads',
    orderTaskListPage: 'orders/:orderId/tasks',
    assetDetailsPage: 'assets/:assetId',
    valuationDetailsPage: 'assets/:assetId/valuations/:valuationId',
    valuationPlausibilityPage: 'assets/:assetId/valuations/:valuationId/plausibility',
    valueCheckDetailsPage: 'assets/:assetId/value-checks/:valueCheckId',
    createOrderPage: 'assets/:assetId/orders/new',
}
